module.exports = __webpack_public_path__ + "img/file.11f8794e.png";